import { HomeIcon } from "../../../../icons";
import MobileNavTab from "./MobileNavTab";

export default function HomeButton({ isActive }) {
	return <MobileNavTab to="/" label="خانه" icon={HomeIcon} isActive={isActive} />;
}
